module.exports = __webpack_public_path__ + "img/generica_spring.c6646e67.svg";